import wait from './wait.vue'

let Waiting = {}
let el = null

// 只有定义了 install 方法，才能使用 Vue.use() 进行引用
Waiting.install = function (Vue) {
  // 添加实例方法 - 扩展方法
  Vue.prototype.$waiting = function () {
  }
  Vue.prototype.$waiting.shows = function (msg) {
    const WaitController = Vue.extend(wait)
    let instance = new WaitController().$mount(document.createElement('div'))
    instance.msg = msg
    el = instance.$el
    document.body.appendChild(el)
  }
  Vue.prototype.$waiting.close = function () {
    if (el) {
      document.body.removeChild(el)
    }
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Waiting)
}

export default Waiting



// WEBPACK FOOTER //
// ./src/components/base/wait/index.js